import { Link } from "react-router-dom";
import { trendingContent } from "@/mocks/siteData";

export default function TrendingSection() {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/2">
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门排行</h2>
              <p className="text-sm text-foreground-500">全网最受欢迎的视频内容</p>
            </div>

            <div className="flex flex-col gap-3">
              {trendingContent.map((item, index) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-200/70 transition-colors group cursor-pointer"
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                    index < 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}>
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h4>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-foreground-500">{item.category}</span>
                      <span className="text-xs text-foreground-400">
                        <i className="ri-eye-line mr-0.5"></i>{formatViews(item.views)}
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">广告合作</h2>
              <p className="text-sm text-foreground-500">优质品牌推广，精准触达目标用户</p>
            </div>

            <div className="relative rounded-lg overflow-hidden aspect-[16/10] bg-gradient-to-br from-accent-100 to-primary-100 p-6 md:p-8 flex flex-col justify-end">
              <div className="absolute top-6 right-6 px-2 py-1 bg-background-50/80 rounded text-xs text-foreground-600">推广</div>
              <div className="relative z-10">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/20 rounded-full mb-3">
                  <i className="ri-megaphone-line text-accent-600 text-sm"></i>
                  <span className="text-xs text-accent-700 font-medium">商务合作</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">想让您的品牌被更多人看到？</h3>
                <p className="text-sm text-foreground-600 mb-4 max-w-md">
                  爱情岛论坛日均百万播放，精准覆盖年轻情感消费群体，是品牌推广的理想平台。
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解合作 <i className="ri-arrow-right-up-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}